export const iframeURLRegex = process.env.VUE_APP_IFRAME_URL_REGEX;

export default {
  iframeURLRegex
};
